import FilterField from "../Field";
import EditIcon from "@/assets/images/icons/edit.svg?inline";
import LoadingIcon from "@/assets/images/icons/loading-white.svg?inline";

import {
  EDIT_PREFERENCES,
  UPDATE_BUYER_PREFERENCES,
  GET_USER
} from "../../../gql/UserProfileQueries";

export default {
  name: "desired-settings",

  data() {
    return {
      allPreferences: [],
      skipEditedPreferencesQuery: true,

      modalCategoryShow: false,
      isShowFilters: false,
      editPreferences: [],
      editImagePreferences: "",
      editedTextCategoryId: null,

      editingCategoryPreferences: [],
      loadingEditedPreferences: false,

      getUser: {},
      skipGetUserQuery: true
    };
  },

  props: ["preferences", "isOwner"],

  apollo: {
    editPreferences: {
      query: EDIT_PREFERENCES,
      fetchPolicy: "no-cache",
      variables() {
        return {
          categoryId: this.editedTextCategoryId
        };
      },
      skip() {
        return this.skipEditedPreferencesQuery;
      },
      result() {
        this.modalCategoryShow = !this.modalCategoryShow;
        this.skipEditedPreferencesQuery = true;
      }
    },

    getUser: {
      query: GET_USER,
      fetchPolicy: "no-cache",
      skip() {
        return this.skipGetUserQuery;
      },
      result({ data: { getUser } }) {
        this.$store.dispatch("initUser", getUser);
        this.skipGetUserQuery = true;
      }
    }
  },

  mounted: function() {
    this.allPreferences = this.preferences;
  },

  computed: {
    textFiltersList() {
      if (this.editPreferences) {
        return this.editPreferences.entities;
      }
    },
    getFilters() {
      return { editPreferences: [] };
    }
  },

  methods: {
    hideModal() {
      this.$refs.modalCategory.hide();
      this.isShowFilters = !this.isShowFilters;
    },

    initEditModal(id) {
      this.editedTextCategoryId = id;
      this.skipEditedPreferencesQuery = false;
    },

    updateSearchParams(data) {
      let filterIndex = this.editingCategoryPreferences.findIndex(
        f => f.tagId == data.tagId
      );

      if (filterIndex >= 0) {
        this.editingCategoryPreferences[filterIndex] = data;
      } else {
        this.editingCategoryPreferences.push(data);
      }
    },

    saveEditedPreferences() {
      this.loadingEditedPreferences = true;
      this.$apollo
        .mutate({
          mutation: UPDATE_BUYER_PREFERENCES,
          variables: {
            filters: this.editingCategoryPreferences,
            categoryId: this.editedTextCategoryId
          }
        })
        .then(({ data: { updateBuyerPreferences: { entities } } }) => {
          let indexOfCategoty = this.allPreferences.textPreferences.findIndex(
            cat => {
              return cat.category.id == this.editedTextCategoryId;
            }
          );

          this.allPreferences.textPreferences[
            indexOfCategoty
          ].entities = entities;

          // this.$set(vm.items, indexOfItem, newValue);

          this.skipGetUserQuery = false;
        })
        .catch(mutationError => {
          const errors = mutationError.graphQLErrors;

          for (let error in errors) {
            this.$toasted.error(errors[error].message);
          }
        })
        .finally(() => {
          this.loadingEditedPreferences = false;
          this.hideModal();
          this.editingCategoryPreferences = [];
          this.editedTextCategoryId = "";
        });
    }
  },

  watch: {},

  components: {
    FilterField,
    EditIcon,
    LoadingIcon
  }
};
